<template>
    <section class="flex-column ml-n2 mr-n2">
        <div class="block block-rounded block-bordered">
            <div class="block-header">
                <div class="block-title">
                    SMS - Bulk outbox
                </div>
            </div>
            <div class="block-content block-content-full tab-content border-top">
                <table class="js-table-checkable table table-striped table-hover table-borderless table-vcenter font-size-sm">
                    <thead>
                    <tr class="text-uppercase">
                        <th class="text-center" style="width: 70px;">
                            <div class="custom-control custom-checkbox custom-control-primary d-inline-block">
                                <input type="checkbox" class="custom-control-input" id="check-all"
                                       v-model="checkAll">
                                <label class="custom-control-label" for="check-all"/>
                            </div>
                        </th>
                        <th>Message</th>
                        <th class="d-none d-sm-table-cell" style="width: 15%;">Type</th>
                        <th class="d-none d-sm-table-cell" style="width: 15%;">Recipients</th>
                        <th class="d-none d-sm-table-cell" style="width: 20%;">Date</th>
                        <th>...</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(message, index) in messages.data" :key="index">
                        <td class="text-center">
                            <div class="custom-control custom-checkbox custom-control-primary d-inline-block">
                                <input :value="message.id" name="alert_id" v-model="alertIds" type="checkbox"
                                       class="custom-control-input" :id="`alert-${message.id}`">
                                <label class="custom-control-label" :for="`alert-${message.id}`"/>
                            </div>
                        </td>
                        <td>
                            <p class="font-w600 mb-1">
                                <span class="strong"> {{message.senderName}} </span>
                            </p>
                            <p class="text-muted mb-0">
                                {{message.message}}
                            </p>
                        </td>
                        <td class="d-none d-sm-table-cell">
                            <span class="badge badge-danger">{{message.messageType}}</span>
                        </td>
                        <td>
                            {{message.totalSent}}
                        </td>
                        <td class="d-none d-sm-table-cell">
                            <em class="font-size-sm text-muted">{{message.createdAt}}</em>
                        </td>
                        <td>
                            <div class="dropdown">
                                <button type="button" class="btn-block-option" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                    <i class="si si-menu"/>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                                    <a @click.prevent="viewMessage(message.id)" class="dropdown-item" href="#">
                                        <i class="far fa-fw fa-folder-open mr-1"/> View Message
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="block-content">
                <div class="mr-4">
                    <eml-pagination :limit="2"
                                align="right"
                                :data="messages"
                                @pagination-change-page="loadMessages"/>
                </div>

            </div>
        </div>
    </section>

</template>

<script>
    import {APP_CONFIG} from "../../config";


    export default {
        name: "AlertsOutbox",
        data() {
            return {
                checkAll: false,
                alertIds: [],
                messages: {
                    data: []
                },
                columns: [
                    'sender',
                    'totalSent',
                    'message',
                    'cost',
                    'sent_at',
                    'status',
                    'action'
                ],
                options: {}
            }
        },
        mounted() {
            this.loadMessages();
        },
        methods: {
            viewMessage(id) {
                let url = `/projects/${this.$route.params.project}/sms/outbox/${id}`
                this.$router.push(url);
            },

            loadMessages(page) {
                return axios.get(APP_CONFIG.URL + `web/projects/${this.$route.params.project}/sms/bulk-outbox`, {
                    params: {page: page}
                }).catch((e) => {
                    this.dispatch('error', e);
                }).then(response => this.messages = response.data);
            }
        }
    }
</script>

<style scoped>

</style>
